'use client';
import { logger, OutputStrategy } from '@magicschool/logger';
import { toast } from '@magicschool/spellbook';
import { getBuildPrefix } from '@magicschool/utils/nextjs/metadata';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { AuthSessionSync } from '@/components/AuthSessionSync/AuthSessionSync';
import { useAuth } from '@/hooks/useAuth';

export function NavigationEvents() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const intl = useIntl();

  const { isSignedIn, userId, userEmail } = useAuth();

  useEffect(() => {
    logger.outputStrategy = OutputStrategy.JSONStringify;
  }, []);

  useEffect(() => {
    if (isSignedIn) {
      logger.userId = userId;
      logger.setLogUser({ id: userId, email: userEmail });
    }
  }, [userId, isSignedIn, userEmail]);

  useEffect(() => {
    if (pathname) {
      logger.path = `${pathname}?${searchParams.toString()}`;
      logger.pathKey = pathname;
      logger.build = getBuildPrefix();
    }
  }, [pathname, searchParams]);

  useEffect(() => {
    const errorValue = searchParams.get('error');
    if (errorValue) {
      let errorId = `error.${errorValue}`;
      errorId = errorId in intl.messages ? errorId : 'toast.error.generic';
      toast({ title: intl.formatMessage({ id: errorId }), status: 'error' });

      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete('error');
      window.history.replaceState({}, '', `${pathname}?${newSearchParams.toString()}`);
    }
  }, [searchParams, intl, pathname]);

  return <AuthSessionSync />;
}
